import React from "react";
import { Menu, MenuItem } from "@blueprintjs/core";
import { useLocation, useNavigate } from "react-router-dom";

export default function ProjectsSidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Menu>
      <MenuItem
        icon="document"
        text="Overview"
        active={location.pathname === "/projects/overview"}
        onClick={() => navigate("/projects/overview")}
      />
      <MenuItem
        icon="calendar"
        text="Calendar"
        active={location.pathname === "/projects/calendar"}
        onClick={() => navigate("/projects/calendar")}
      />
      <MenuItem
        icon="timeline-area-chart"
        text="Gantt Chart"
        active={location.pathname === "/projects/gantt"}
        onClick={() => navigate("/projects/gantt")}
      />
      <MenuItem
        icon="projects"
        text="Kanban"
        active={location.pathname === "/projects/kanban"}
        onClick={() => navigate("/projects/kanban")}
      />
    </Menu>
  );
}
